export enum UserDeviceType {
  PC = 'PC',
  SP = 'SP',
  TB = 'TABLET',
}
